import store from "../../store";
import { IFixedPhraseTextDragParameter } from ".";
import { DomainRegistry } from "../../domain";
import { NewObjectKeys } from "../../domain/configuration";
import { FixedPhraseTextKinds } from "../../domain/document";
import { IDrawableItem, AbstractPlainTextItem } from "../../domain/document/items";
import { Point, Size, Rectangle, TextStyle } from "../../domain/drawing";

export class FixedPhraseTextDropManager {
  constructor(
    event?: DragEvent,
    private _page?: HTMLDivElement,
    private _scale?: number,
    private _getTextSize?: (text: string, textStyle: TextStyle) => Size,
    private _addItem?: (item: IDrawableItem) => void,
    private _createText?: (parameter: IFixedPhraseTextDragParameter) => Promise<string>
  ) {
    this._clientX = !!event ? event.clientX : 0;
    this._clientY = !!event ? event.clientY : 0;
  }

  private _clientX: number;
  private _clientY: number;

  get parameter(): IFixedPhraseTextDragParameter {
    return store.state.fixedPhraseTextDragParameter;
  }

  set parameter(payload: IFixedPhraseTextDragParameter) {
    store.commit("setFixedPhraseTextDragParameter", payload);
  }

  async run(): Promise<boolean> {
    try {
      if (!this.parameter) { return false; }
      switch (this.parameter.kind) {
        case FixedPhraseTextKinds.Text:
          await this.addItem("NewText");
          return true;
        case FixedPhraseTextKinds.Tag:
          await this.addItem("NewTag");
          return true;
        default:
          return false;
      }
    } catch (e) {
      return false;
    } finally {
      this.parameter = null;
    }
  }

  private async addItem<T extends AbstractPlainTextItem = AbstractPlainTextItem>(key: NewObjectKeys): Promise<void> {
    const text = await this.createText();
    if (!text) {
      return;
    }
    const repository = DomainRegistry.document.getDocumentRepository();
    const result = await repository.createNewObjects(key) as T;
    result.geometry.rectangle = this.createRectangle(result.textStyle);
    result.value = text;
    this._addItem(result);
  }

  private async createText(): Promise<string> {
    return this._createText
      ? this._createText(this.parameter)
      : this.parameter.text;
  }
  
  private createRectangle(textStyle: TextStyle): Rectangle {
    const pageRect = this._page.getBoundingClientRect();
    const pointerX = Math.round((this._clientX + this._page.scrollLeft - pageRect.left) / this._scale);
    const pointerY = Math.round((this._clientY + this._page.scrollTop - pageRect.top) / this._scale);
    const size = this._getTextSize(this.parameter.text, textStyle);
    return new Rectangle(new Point(pointerX, pointerY), size);
  }
}
